import type { ReactNode } from 'react'

export const ErrorWidget = (props: { error: string | ReactNode; onRemove: () => void }) => {
  const buildError = (e: string | ReactNode) => {
    if (typeof e === 'string') {
      const sep = e.split('\n')
      if (sep.length > 1) {
        return (
          <div className="flex flex-col">
            {sep.map((x, index) => (
              <div key={index}>{x}</div>
            ))}
          </div>
        )
      }
      return e
    }
    return e
  }

  return (
    <div
      data-testid="error-widget"
      className="flex flex-row justify-between rounded-sm border-red-400 bg-red-800 text-white m-2 shadow-sm p-2"
    >
      <span></span>
      <span className="font-bold text-lg">{buildError(props.error)}</span>
      <button onClick={() => props.onRemove()}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  )
}
